import { BoardMember } from './api';

export const BOARD_MEMBER_EVENT_NAMES = {
  added: '.member.added',
  roleChanged: '.member.role_changed',
  removed: '.member.removed',
} as const;

export interface BoardMemberAddedEvent {
  member: BoardMember;
  board_id: number;
  // Id de la BoardInvitation personnelle consommée par cette acceptation,
  // null si l'ajout vient du lien partageable générique du board.
  invitation_id: number | null;
}

export interface BoardMemberRoleChangedEvent {
  user_id: number;
  role: 'admin' | 'editor' | 'visitor';
  board_id: number;
}

export interface BoardMemberRemovedEvent {
  user_id: number;
  board_id: number;
}

export const applyBoardMemberAdded = (
  members: BoardMember[],
  boardId: number,
  event: BoardMemberAddedEvent
): BoardMember[] => {
  if (event.board_id !== boardId) return members;
  if (members.some((m) => m.id === event.member.id)) return members;
  return [...members, event.member];
};

export const applyBoardMemberRoleChanged = (
  members: BoardMember[],
  boardId: number,
  event: BoardMemberRoleChangedEvent
): BoardMember[] => {
  if (event.board_id !== boardId) return members;
  return members.map((m) => (m.id === event.user_id ? { ...m, role: event.role } : m));
};

export const applyBoardMemberRemoved = (
  members: BoardMember[],
  boardId: number,
  event: BoardMemberRemovedEvent
): BoardMember[] => {
  if (event.board_id !== boardId) return members;
  return members.filter((m) => m.id !== event.user_id);
};
